import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateActive = (matchId, active, token) => async dispatch => {
    dispatch({
        type: actionTypes.UPDATE_ACTIVE_START
    });
    const options = {
        url: `${api}/matches/${matchId}/updateActive`,
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        data: {
            active
        }
    }
    await axios(options)
        .then(response => {
            dispatch({
            type: actionTypes.UPDATE_ACTIVE_SUCCESS,
            payload: response.data
        })})
        .catch(error => dispatch({
            type: actionTypes.UPDATE_ACTIVE_FAIL,
            payload: getMessage(error)
        }))
}